export const classes = {
  item: 'flex items-center cursor-pointer select-none rounded-lg mx-1 my-0.5 px-3 py-2 text-taupe-3 hover:bg-black/5 dark:text-mauve-1 dark:hover:bg-white/5',
};
